<div>
    <div class="text-right" style="position: fixed; bottom: 30px; z-index: 10;font-size: larger;">
        <button class="btn btn-danger btn-circle fa fa-close" style="width: 70px;
        height: 70px;
        font-size: 34px;" title="close All Vists" (click)="closeAllVists()"></button>
    </div>
    <div class="row d-flex align-items-center justify-content-start" style=" width: 100%;">
        <div class="col-4">
            <sanabel-selectize [(ngModel)]="vSerial" #childServiceSelectize (clicked)="getVisitSerial($event)"
                [SearchKeys]="{PatCode:patCode}" [appcode]="1096">
            </sanabel-selectize>
        </div>
        <div class="col-1 d-flex align-items-center">
            <button type="submit" [ngClass]="'min-class'" placement="top"
                ngbTooltip="{{!toggleVisit ? 'Show Visit Data' : 'Show All VisitData'}}" tabindex="1"
                (click)="onShowAllVisitChange()" [style.background]="!toggleVisit ? '#dc3545': '#38c6d3'"
                style="border: none;border-radius: 15%; margin-top: 28px;height: 52%;">
                <span class="fa fa-custom" style="padding-bottom: 5px;"
                    [ngClass]="{'fa-file-o': !toggleVisit, 'fa-file-text-o': toggleVisit}"></span>
            </button>
        </div>
    </div>
    <br>
    <div class="row">
        <div class=" mb-4"
            style=" width: 32%;margin-right: 5px;margin-left: 5px;border: 1px solid #0542e8; border-radius: 5px; padding: 10px;">
            <h3 class="text-center font-weight-bold"
                style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;"
                [class.hidden-header]="isScrolling">
                {{'COMPLAINTS' | translate}}
            </h3>
            <div style="height: 305px;overflow-y: auto;">
                <hr class="mb-0" />
                <div *ngIf="groupedComplaints.length == 0" class="text-center radibox">
                    <span class="text-danger font-weight-bold"> No complaints</span>
                </div>
                <div *ngFor="let group of groupedComplaints" class="group-container">
                    <h6 class="font-weight-bold" style="color: blue; display: flex; justify-content: space-between;">
                        <span> {{translate.currentLang == 'ar'? group.specialtyNameAr :
                            group.specialtyNameEn}}</span>
                        <span>{{'VISITNO' | translate}}:{{ group.visitNo }}</span>
                        <span>{{group.regDate | date:'dd/MM/yy, h:mm a'}}</span>
                    </h6>
                    <hr class="my-0" />
                    <ul>
                        <div *ngFor="let item of group.items" class="radibox">
                            <div *ngIf="item.deleteStatus !=1" class="radicon-2020 row mx-0 align-items-center py-1">
                                <span class="col px-0 text-overflow-wrap">{{item.complainDesc ?
                                    item.complainDesc :
                                    item.notes}}</span>
                            </div>
                        </div>
                    </ul>
                </div>
                <hr *ngIf="groupedComplaints.length > 0" class="mb-0" />
            </div>
        </div>
        <div class=" mb-4"
            style=" width: 32%;margin-right: 5px;margin-left: 5px;border: 1px solid #0542e8; border-radius: 5px; padding: 10px;">
            <h3 class="text-center font-weight-bold"
                style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;">
                {{'DIAGNOSES' | translate}}
            </h3>
            <div style="height: 305px;overflow-y: auto;">
                <hr class="mb-0" />
                <div *ngIf="groupedDiagnosis.length == 0" class="text-center radibox">
                    <span class="text-danger font-weight-bold"> No Diagnosis</span>
                </div>
                <div *ngFor="let group of groupedDiagnosis" class="group-container">
                    <h6 class="font-weight-bold" style="color: blue; display: flex; justify-content: space-between;">
                        <span> {{translate.currentLang == 'ar'? group.specialtyNameAr :
                            group.specialtyNameEn}}</span>
                        <span>{{'VISITNO' | translate}}:{{ group.visitNo }}</span>
                        <span>{{group.regDate | date:'dd/MM/yy, h:mm a'}}</span>
                    </h6>
                    <hr class="my-0" />
                    <ul>
                        <div *ngFor="let item of group.items" class="radibox">
                            <div *ngIf="item.deleteStatus !=1" class="radicon-2020 row mx-0 align-items-center py-1">
                                <span class="col px-0 text-overflow-wrap">{{translate.currentLang == 'ar'?
                                    item.diagnosisDesc : item.diagnosisDesc}}</span>
                            </div>
                        </div>
                    </ul>
                </div>
                <hr *ngIf="groupedDiagnosis.length > 0" class="mb-0" />
            </div>
        </div>
        <div class=" mb-4"
            style=" width: 32%;margin-right: 5px;margin-left: 5px;border: 1px solid #0542e8; border-radius: 5px; padding: 10px;">
            <h3 class="text-center font-weight-bold"
                style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;">
                {{'FINDING' | translate}}
            </h3>
            <div style="height: 305px;overflow-y: auto;">
                <hr class="mb-0" />
                <div *ngIf="groupedFinding.length == 0" class="text-center radibox">
                    <span class="text-danger font-weight-bold"> No FINDING</span>
                </div>
                <div *ngFor="let group of groupedFinding" class="group-container">
                    <h6 class="font-weight-bold" style="color: blue; display: flex; justify-content: space-between;">
                        <span> {{translate.currentLang == 'ar'? group.specialtyNameAr :
                            group.specialtyNameEn}}</span>
                        <span>{{'VISITNO' | translate}}:{{ group.visitNo }}</span>
                        <span>{{group.regDate | date:'dd/MM/yy, h:mm a'}}</span>
                    </h6>
                    <hr class="my-0" />
                    <ul>

                        <div *ngFor="let item of group.items" class="radibox">
                            <div *ngIf="item.deleteStatus !=1" class="radicon-2020 row mx-0 align-items-center py-1">
                                <span class="col px-0 text-overflow-wrap">{{translate.currentLang == 'ar'?
                                    item.description : item.description}}</span>
                            </div>
                        </div>

                    </ul>
                </div>
                <hr *ngIf="groupedFinding.length > 0" class="mb-0" />
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class=" mb-4"
            style=" width: 32%;margin-right: 5px;margin-left: 5px;border: 1px solid #0542e8; border-radius: 5px; padding: 10px;">
            <h3 class="text-center font-weight-bold"
                style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;"
                [class.hidden-header]="isScrolling">
                {{'MEDICATIONDOSES' | translate}}
            </h3>
            <div style="height: 305px;overflow-y: auto;">
                <hr class="mb-0" />
                <div *ngIf="groupedMedications.length == 0" class="text-center radibox">
                    <span class="text-danger font-weight-bold"> No Medications</span>
                </div>
                <div *ngFor="let group of groupedMedications" class="group-container">
                    <h6 class="font-weight-bold" style="color: blue; display: flex; justify-content: space-between;">
                        <span> {{translate.currentLang == 'ar'? group.specialtyNameAr :
                            group.specialtyNameEn}}</span>
                        <span>{{'VISITNO' | translate}}:{{ group.visitNo }}</span>
                        <span>{{group.regDate | date:'dd/MM/yy, h:mm a'}}</span>
                    </h6>
                    <hr class="my-0" />
                    <ul>
                        <div *ngFor="let item of group.items" class="radibox">

                            <div class="radicon-2020 row mx-0 align-items-center">
                                <!-- <b class="text-black col-12 px-0"
                                    title="{{translate.currentLang == 'ar'? 'د/'+item.nameAr : 'Dr/'+item.nameEn}}">
                                    {{translate.currentLang == 'ar'? item.nameAr : item.nameEn}}</b> -->
                                <span class="col-12 px-0 text-overflow-wrap"> {{translate.currentLang == 'ar'?
                                    item.nameAr : item.nameEn}}</span>
                            </div>


                        </div>
                    </ul>
                </div>
                <hr *ngIf="groupedMedications.length > 0" class="mb-0" />
            </div>
        </div>
        <div class=" mb-4"
            style=" width: 32%;margin-right: 5px;margin-left: 5px;border: 1px solid #0542e8; border-radius: 5px; padding: 10px;">
            <h3 class="text-center font-weight-bold"
                style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;">
                {{'LABORATORY' | translate}}
            </h3>
            <div style="height: 305px;overflow-y: auto;">
                <hr class="mb-0" />
                <div *ngIf="groupedLabData.length == 0" class="text-center radibox">
                    <span class="text-danger font-weight-bold"> No Lab Tests</span>
                </div>
                <div *ngFor="let group of groupedLabData" class="group-container">
                    <h6 class="font-weight-bold" style="color: blue; display: flex; justify-content: space-between;">
                        <span> {{translate.currentLang == 'ar'? group.specialtyNameAr :
                            group.specialtyNameEn}}</span>
                        <span>{{'VISITNO' | translate}}:{{ group.visitNo }}</span>
                        <span>{{group.regDate | date:'dd/MM/yy, h:mm a'}}</span>
                    </h6>
                    <hr class="my-0" />
                    <ul>
                        <div *ngFor="let item of group.items" class="radibox">
                            <div class="radicon-2020 row mx-0 align-items-center" [ngClass]="{
                            'text-danger': item.abnormality == null,
                            'text-success': item.abnormality != null
                        }" title="{{item.abnormality == null ? 'Normal' : 'Abnormal'}}">
                                <span class="col-10 px-0 text-overflow-wrap">
                                    {{translate.currentLang == 'ar'? item.serviceNameAr :
                                    item.serviceNameEn}}</span>
                                <b class="text-black col-2 px-0">
                                    {{translate.currentLang == 'ar'? item.serviceStatusAr :
                                    item.serviceStatusEn}}</b>

                            </div>
                        </div>
                    </ul>
                </div>
                <hr *ngIf="groupedLabData.length > 0" class="mb-0" />
            </div>
        </div>
        <div class=" mb-4"
            style=" width: 32%;margin-right: 5px;margin-left: 5px;border: 1px solid #0542e8; border-radius: 5px; padding: 10px;">
            <h3 class="text-center font-weight-bold"
                style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;">
                {{'RADIOLOGY' | translate}}
            </h3>
            <div style="height: 305px;overflow-y: auto;">
                <hr class="mb-0" />
                <div *ngIf="groupedRadData.length == 0" class="text-center radibox">
                    <span class="text-danger font-weight-bold"> No Radiology Data</span>
                </div>
                <div *ngFor="let group of groupedRadData" class="group-container">
                    <h6 class="font-weight-bold" style="color: blue; display: flex; justify-content: space-between;">
                        <span> {{translate.currentLang == 'ar'? group.specialtyNameAr :
                            group.specialtyNameEn}}</span>
                        <span>{{'VISITNO' | translate}}:{{ group.visitNo }}</span>
                        <span>{{group.regDate | date:'dd/MM/yy, h:mm a'}}</span>
                    </h6>
                    <hr class="my-0" />
                    <ul>
                        <div *ngFor="let item of group.items" class="radibox">
                            <div class="radicon-2020 row mx-0 align-items-center" [ngClass]="{
                                'text-danger': item.abnormality == null,
                                'text-success': item.abnormality != null
                            }" title="{{item.abnormality == null ? 'Normal' : 'Abnormal'}}">
                                <span class="col-10 px-0 text-overflow-wrap">{{translate.currentLang == 'ar'?
                                    item.serviceNameAr : item.serviceNameEn}}</span>
                                <b class="text-black col-2 px-0">{{translate.currentLang == 'ar'?
                                    item.serviceStatusAr :
                                    item.serviceStatusEn}}</b>

                            </div>
                        </div>
                    </ul>
                </div>
                <hr *ngIf="groupedRadData.length > 0" class="mb-0" />
            </div>
        </div>
    </div>
    <br>

    <div class="row">
        <div class=" mb-4"
            style=" width: 32%;margin-right: 5px;margin-left: 5px;border: 1px solid #0542e8; border-radius: 5px; padding: 10px;">
            <h3 class="text-center font-weight-bold"
                style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;">
                {{'VITALSIGNS' | translate}}
            </h3>
            <div style="height: 305px;overflow-y: auto;">
                <hr class="mb-0" />
                <div *ngIf="groupedVitals.length == 0" class="text-center radibox">
                    <span class="text-danger font-weight-bold"> No Vital Sign</span>
                </div>
                <div *ngFor="let group of groupedVitals" class="group-container">
                    <h6 class="font-weight-bold" style="color: blue; display: flex; justify-content: space-between;">
                        <span> {{translate.currentLang == 'ar'? group.specialtyNameAr :
                            group.specialtyNameEn}}</span>
                        <span>{{'VISITNO' | translate}}:{{ group.visitNo }}</span>
                        <span>{{group.regDate | date:'dd/MM/yy, h:mm a'}}</span>
                    </h6>
                    <hr class="my-0" />
                    <ul>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Height</th>
                                    <th>Weight</th>
                                    <th>Sat</th>
                                    <th>Respiratory</th>
                                    <th>Low Pressure</th>
                                    <th>High Pressure</th>
                                    <th>Pulse</th>
                                    <th>Temperature</th>
                                    <th>Blood Sugar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of group.items">
                                    <td>{{item.height}}</td>
                                    <td>{{item.weight}}</td>
                                    <td>{{item.sat}}</td>
                                    <td>{{item.respiratory}}</td>
                                    <td>{{item.lowPressure}}</td>
                                    <td>{{item.highPressure}}</td>
                                    <td>{{item.pulse}}</td>
                                    <td>{{item.temperature}}</td>
                                    <td>{{item.bloodSuger}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </ul>

                </div>
                <hr *ngIf="groupedVitals.length > 0" class="mb-0" />
            </div>
        </div>
        <!-- ----============================================================================ -->
        <div class=" mb-4"
            style=" width: 32%;margin-right: 5px;margin-left: 5px;border: 1px solid #0542e8; border-radius: 5px; padding: 10px;">
            <h3 class="text-center font-weight-bold"
                style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;">
                {{'Leads' | translate}}
            </h3>
            <div style="height: 305px;overflow-y: auto;">
                <hr class="mb-0" />
                <div *ngIf="groupedLeads.length == 0" class="text-center radibox">
                    <span class="text-danger font-weight-bold"> No leads</span>
                </div>
                <div *ngFor="let group of groupedLeads" class="group-container">
                    <h6 class="font-weight-bold" style="color: blue; display: flex; justify-content: space-between;">
                        <span> {{translate.currentLang == 'ar'? group.specialtyNameAr :
                            group.specialtyNameEn}}</span>
                        <span>{{'VISITNO' | translate}}:{{ group.visitNo }}</span>
                        <span>{{group.regDate | date:'dd/MM/yy, h:mm a'}}</span>
                    </h6>
                    <hr class="my-0" />
                    <ul>
                        <div *ngFor="let item of group.items" class="radibox">

                            <div class="radicon-2020 row mx-0 align-items-center">
                                <span class="col-12 px-0 text-overflow-wrap">
                                    {{translate.currentLang == 'ar'? item.serviceName :
                                    item.serviceName}}</span>
                                <b class="text-black col-12 px-0">
                                    {{translate.currentLang == 'ar'? item.doctorNameAr : item.doctorNameAr}}</b>
                                <span class="datec col-6 px-0 text-right">
                                    {{item.operationDate | date:'dd/MM/yy, h:mm a'}}
                                </span>
                                <span *ngIf="item.operationStatus ==1 " class="datec col-6 px-0 text-right">
                                    Executed
                                </span>
                                <span *ngIf="item.operationStatus ==0 " class="datec col-6 px-0 text-right">
                                    Not Executed
                                </span>
                            </div>


                        </div>
                    </ul>
                </div>
                <hr *ngIf="groupedLeads.length > 0" class="mb-0" />
            </div>
        </div>
    </div>
</div>
<!-- <div class="row h-30">
        <div class="col">
            <p-dataTable tableStyleClass="table table-bordered table-striped ui-state-highlight" [value]="allVisits"
                selectionMode="single" [rows]="10" [paginator]="true" [pageLinks]="3"
                [rowsPerPageOptions]="[5,10,20,50,100]">

                <p-column [style]="{'width': '5%'}" field="code" header="{{ 'CODE' | translate }}" [sortable]="true">
                </p-column>

                <p-column [style]="{'width': '5%'}" field="visitSerial" header="{{ 'VISITSNUMBER' | translate }}"
                    [sortable]="true">
                </p-column>

                <p-column [style]="{'width': '5%'}" field="visitNo" header="{{ 'VISITNUM' | translate }}"
                    [sortable]="true">
                </p-column>

                <p-column [style]="{'width': '15%'}" header="{{ 'PATIENT' | translate }}" [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        <div>
                            {{ translate.currentLang == 'ar' ? row.patientNameAr : row.patientNameEn }}
                        </div>
                    </ng-template>
                </p-column>

                <p-column [style]="{'width': '15%'}" header="{{ 'DOCTOR' | translate }}" [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        <div>
                            {{ translate.currentLang == 'ar' ? row.docNameAr: row.docNameEn }}
                        </div>
                    </ng-template>
                </p-column>

                <p-column [style]="{'width': '15%'}" header="{{ 'SPECIALITY' | translate }}" [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        <div>
                            {{ translate.currentLang == 'ar' ? row.specialtyNameAr: row.specialtyNameEn }}
                        </div>
                    </ng-template>
                </p-column>

                <p-column [style]="{'width': '10%'}" header="{{ 'VISITSNUMBER' | translate }}" [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        <div>
                            {{ translate.currentLang == 'ar' ? row.visitStatusAr: row.visitStatusEn }}
                        </div>
                    </ng-template>
                </p-column>

                <p-column [style]="{'width': '15%'}" header="{{ 'SERVICENAME' | translate }}" [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        <div>
                            {{ translate.currentLang == 'ar' ? row.serviceNameAr : row.serviceNameEn }}
                        </div>
                    </ng-template>
                </p-column>

                <p-column [style]="{'width': '10%'}" header="{{ 'StartDate' | translate }}" [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        <div>
                            {{ row.visitStartDate | date:'dd/MM/yy, h:mm a' }}
                        </div>
                    </ng-template>
                </p-column>

                <p-column [style]="{'width': '5%'}" header="{{ 'ACTIONS' | translate }}">
                    <ng-template pTemplate="options" let-row="rowData">
                        <icon-action (clicked)="onRowClick($event,row)" [appCodes]="[404,2132]">
                        </icon-action>
                    </ng-template>
                </p-column>
            </p-dataTable>
        </div>
    </div> -->
<!-- <div *ngIf="showMedicalData"> -->
<!-- <div class="row h-70 my-4 " style="width: 180% !important;"> -->
<!-- <div class="col">
                <h3 class="text-center font-weight-bold "
                    style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;">
                    {{'COMPLAINTS' | translate}}
                </h3>
                <hr class="mb-0" />
                <ul class="ulitem radilco list-unstyled">
                    <li *ngFor="let item of complaints" class="radibox">
                        <div *ngIf="item.deleteStatus !=1" class="radicon-2020 row mx-0 align-items-center py-1">
                            <span class="col px-0 text-overflow-wrap">{{item.complainDesc ? item.complainDesc :
                                item.notes}}</span>

                            <span class="datec col px-0 text-right">{{item.regDate | date:'dd/MM/yy, h:mm a'}}</span>
                            <span class="fas fa-copy ml-2" style="font-size: 14px;" title="copy"
                                (click)="Copycomplaint(item)"></span>
                        </div>
                        <hr class="my-0" />
                    </li>
                    <li *ngIf="!complaints || complaints.length == 0" class="text-center radibox">
                        <span class="text-danger font-weight-bold"> No complaints</span>
                    </li>
                </ul>
            </div> -->

<!-- <div class="col"> -->
<!-- <h3 class="text-center font-weight-bold "
                    style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;">
                    {{'DIAGNOSES' | translate}}
                </h3>
                <hr class="mb-0" />
                <ul class="ulitem radilco list-unstyled">
                    <li *ngFor="let item of diagnosis" class="radibox">
                        <div *ngIf="item.deleteStatus !=1" class="radicon-2020 row mx-0 align-items-center py-1">
                            <span class="col px-0 text-overflow-wrap">{{translate.currentLang == 'ar'?
                                item.diagnosisDesc : item.diagnosisDesc}}</span>

                            <span class="datec col px-0 text-right">{{item.regDate | date:'dd/MM/yy, h:mm a'}}</span>
                            <span class="fas fa-copy ml-2" style="font-size: 14px;" title="copy"
                                (click)="CopyDiagnosis(item)"></span>
                        </div>
                        <hr class="my-0" />
                    </li>
                    <li *ngIf="!diagnosis || diagnosis.length == 0" class="text-center radibox">
                        <span class="text-danger font-weight-bold"> No diagnosis</span>
                    </li>
                </ul> -->

<!-- </div> -->
<!-- <div class="col">
                <h3 class="text-center font-weight-bold "
                    style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;">
                    {{'Leads' | translate}}
                </h3>
                <hr class="mb-0" />
                <ul class="ulitem laborat list-unstyled">
                    <li *ngFor="let item of leads" class="radibox">
                        <div class="radicon-2020 row mx-0 align-items-center">
                            <span class="col-12 px-0 text-overflow-wrap">
                                {{translate.currentLang == 'ar'? item.serviceName : item.serviceName}}</span>
                            <b class="text-black col-12 px-0">
                                {{translate.currentLang == 'ar'? item.doctorNameAr : item.doctorNameAr}}</b>
                            <span class="datec col-6 px-0 text-right">
                                {{item.operationDate | date:'dd/MM/yy, h:mm a'}}
                            </span>
                            <span *ngIf="item.operationStatus ==1 " class="datec col-6 px-0 text-right">
                                Executed
                            </span>
                            <span *ngIf="item.operationStatus ==0 " class="datec col-6 px-0 text-right">
                                Not Executed
                            </span>
                        </div>
                        <hr class="my-0" />
                    </li>
                    <li *ngIf="!leads || leads.length == 0" class="text-center radibox">
                        <span class="text-danger font-weight-bold"> No leads</span>
                    </li>
                </ul>
            </div> -->
<!-- <div class="col"> -->
<!-- <h3 class="text-center font-weight-bold "
                    style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;">
                    {{'LABORATORY' | translate}}
                </h3>
                <hr />
                <ul class="ulitem laborat list-unstyled">
                    <li *ngFor="let item of labData" class="radibox">
                        <div class="radicon-2020 row mx-0 align-items-center" [ngClass]="{
            'text-danger': item.abnormality == null,
            'text-success': item.abnormality != null
        }" title="{{item.abnormality == null ? 'Normal' : 'Abnormal'}}">
                            <span class="col-12 px-0 text-overflow-wrap">
                                {{translate.currentLang == 'ar'? item.serviceNameAr : item.serviceNameEn}}</span>
                            <b class="text-black col-2 px-0">
                                {{translate.currentLang == 'ar'? item.serviceStatusAr : item.serviceStatusEn}}</b>
                            <span class="datec col-5 px-0 text-right">
                                {{item.expectedStartTime | date:'dd/MM/yy, h:mm a'}}
                            </span>
                        </div>
                        <hr class="my-0" />
                    </li>
                    <li *ngIf="!labData || labData.length == 0" class="text-center radibox">
                        <span class="text-danger font-weight-bold"> No Lab Tests</span>
                    </li>
                </ul> -->
<!-- </div> -->
<!-- <div class="col">
                <h3 class="text-center font-weight-bold "
                    style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;">
                    {{'RADIOLOGY' | translate}}
                </h3>
                <hr />
                <ul class="ulitem radilco list-unstyled">
                    <li *ngFor="let item of radData" class="radibox">
                        <div class="radicon-2020 row mx-0 align-items-center" [ngClass]="{
            'text-danger': item.abnormality == null,
            'text-success': item.abnormality != null
        }" title="{{item.abnormality == null ? 'Normal' : 'Abnormal'}}">
                            <span class="col-12 px-0 text-overflow-wrap">{{translate.currentLang == 'ar'?
                                item.serviceNameAr : item.serviceNameEn}}</span>
                            <b class="text-black col-2 px-0">{{translate.currentLang == 'ar'? item.serviceStatusAr :
                                item.serviceStatusEn}}</b>
                            <span class="datec col-5 px-0 text-right">{{item.expectedStartTime | date:'dd/MM/yy, h:mm
                                a'}}</span>
                        </div>
                        <hr class="my-0" />
                    </li>
                    <li *ngIf="!radData || radData.length == 0" class="text-center radibox">
                        <span class="text-danger font-weight-bold"> No Radiology Data</span>
                    </li>
                </ul>
            </div> -->
<!-- <div class="col">
                <h3 class="text-center font-weight-bold "
                    style="border: 1px solid #4caf50;color: #4caf50;width: fit-content;padding: 2px 20px;margin: auto;">
                    {{'MEDICATIONDOSES' | translate}}
                </h3>
                <hr />
                <ul class="ulitem laborat list-unstyled">
                    <li *ngFor="let item of medications" class="radibox">
                        <div class="radicon-2020 row mx-0 align-items-center">
                            <span class="col-4 px-0 text-overflow-wrap"
                                title="{{translate.currentLang == 'ar'? item.docNameAr : item.docNameEn}}">
                                {{translate.currentLang == 'ar'? item.docNameAr : item.docNameEn}}</span>
                            <b class="text-black text-center col-4 px-0"
                                title="{{translate.currentLang == 'ar'? 'د/'+item.nameAr : 'Dr/'+item.nameEn}}">
                                {{translate.currentLang == 'ar'? item.nameAr : item.nameEn}}</b>
                            <span class="datec col-4 px-0 text-right text-overflow-wrap"
                                title="{{item.startDate |date:'short'}}">
                                {{item.startDate |date:'short'}}
                            </span>
                        </div>
                        <hr class="my-0" />
                    </li>
                    <li *ngIf="!medications || medications.length == 0" class="text-center radibox">
                        <span class="text-danger font-weight-bold"> No Medications</span>
                    </li>
                </ul>

            </div> -->
<!-- </div> -->